<template>
  <div class="first_page">
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <nav aria-label="breadcrumb" v-if="is_load">
      <ol class="breadcrumb">
         <li class="breadcrumb-item"><router-link tag="a" to="/shop" >На продажу</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ category.title}}</li>
      </ol>
    </nav>
    <section class="section section section-shaped my-0 overflow-hidden content_background_color_blue2" v-if="is_load">
      <div class="shape shape-style-1 bg-gradient-warning ">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>

      </div>

      <div class="container py-0 ">
        <div class="row row-grid mb-5 align-items-center">
          <div class="d-flex px-3">
            <div>
              <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                    rounded></icon>
            </div>
            <div class="pl-4">
              <h4 class="display-3">На продажу</h4>

            </div>
          </div>

          <div class="row col-md-12 mt-3" v-if="items.length>0">
            <router-link v-for="item in items" :key="item.last_id"
                         v-if="items.length>0"
                         :to="{name: 'shop_item_id', params: { id: item.last_id }}">
              <div class="section_gray_bg">
                <a href="#">

                  <sui-image :src="item.photos[0]"/>
                </a>
                <sui-card-content>
                  <sui-card-header><a>{{ item.title }}</a></sui-card-header>
                  <sui-card-meta>

                    <a>Подробнее</a>

                  </sui-card-meta>
                </sui-card-content>
              </div>
            </router-link>


          </div>


        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Api from "../../models/Api";
import Vue from "vue";
import LoadingBlock from "@/components/Custom/LoadingBlock";




var Avatar = require('vue-avatar');


export default {
  name: 'home',

  components: {LoadingBlock},
  data() {
    return {
      "category":null,
      "items":[],
      "is_load":false,
    }
  },
  mounted() {
    var category_id=this.$route.params.id;

    var app=this;
    Api.loadItemsCategory(category_id,function(data){


      app.category=data.category;
      app.items=data.items;
      app.is_load=true;
    })
  },
  methods: {





  }
};
</script>
